import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import * as _ from 'lodash';
import { AppState } from 'app/reducers';
import { Store, select } from '@ngrx/store';
import { PayrollSyntheseSelectors } from '../../selectors';
import { Observable, Subject } from 'rxjs';
import { AnalyticsSelectors } from 'app/main/analytics/selectors';
import { selectCubeForResultat } from 'app/main/cube/cube.selectors';
import { map, groupBy, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-payroll-ana2',
  templateUrl: './payroll-ana2.component.html',
  styleUrls: ['./payroll-ana2.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PayrollAna2Component implements OnInit, OnChanges, OnDestroy {
  // tslint:disable-next-line: no-input-rename
  rowDataPercentage$: Observable<any>;

  @Input() ana2Rows: any[];
  @Input() years: string[];

  unsubscribeAll: Subject<any>;
  percentageByTimeline$: Observable<any>;
  ana2$: Observable<any>;
  cubeResultat$: Observable<any>;
  costPay$: Observable<any>;

  costPayName: string;

  constructor(protected store: Store<AppState>) {
    this.unsubscribeAll = new Subject();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  ngOnInit(): void {
    this.ana2Rows = this.ana2Rows.filter((ana2) => ana2.choice !== 'N/A');

    this.rowDataPercentage$ = this.store.pipe(
      takeUntil(this.unsubscribeAll),
      select(
        PayrollSyntheseSelectors.selectPayrollSyntheseBy(
          'percentage',
          'Analytics',
          this.ana2Rows
        )
      )
    );

    this.rowDataPercentage$
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((ana2Rows) => {
        const percentageByTimeline = {};
        ana2Rows.forEach((ana2) => {
          ana2.items.forEach((item) => {
            if (!percentageByTimeline[item.timeline]) {
              percentageByTimeline[item.timeline] = 0;
            }
            percentageByTimeline[item.timeline] += item.value;
          });
        });
        this.percentageByTimeline$ = new Observable((observer) => {
          observer.next(percentageByTimeline);
        });
      });

    this.ana2$ = this.store.pipe(
      takeUntil(this.unsubscribeAll),
      select(AnalyticsSelectors.selectAna2)
    );

    this.costPay$ = this.store.pipe(
      takeUntil(this.unsubscribeAll),
      select(AnalyticsSelectors.selectGroups),
      map((ana2Group) => _.find(ana2Group, { name: 'Coût Paye' }))
    );

    this.costPay$.pipe(takeUntil(this.unsubscribeAll)).subscribe((c) => {
      this.costPayName = c.name;
    });

    this.cubeResultat$ = this.store.pipe(
      takeUntil(this.unsubscribeAll),
      select(selectCubeForResultat)
    );
  }

  ngOnChanges(simpleChange: SimpleChanges): void {}
}
